import React from 'react';
import { Card, Table, Typography } from 'antd';
import { requestform } from '../../../messages';
import { GetCmisProcessingProgress } from '../../../hooks/request-form';
import dayjs from 'dayjs';

interface ticketCreateInformation {
  cmisRequestId: string;
  closeCmisProcess: () => void;
}

const ModalCmisProcessingProgress: React.FC<ticketCreateInformation> = ({ cmisRequestId, closeCmisProcess }) => {
  const { cmisProcessingProgress, isLoading } = GetCmisProcessingProgress(cmisRequestId || '');

  const menuCmis = [
    {
      title: (
        <Typography.Text className='text-[12px]/[20px] font-semibold text-[#868D97]'>Ngày bắt đầu</Typography.Text>
      ),
      dataIndex: 'startDate',
      render: (text: string) => (
        <Typography.Text className='text-[14px]/[18px] text-[#141414]'>
          {dayjs(text).format('DD/MM/YYYY')}
        </Typography.Text>
      ),
      width: '15%'
    },
    {
      title: (
        <Typography.Text className='text-[12px]/[20px] font-semibold text-[#868D97]'>Nội dung xử lý</Typography.Text>
      ),
      dataIndex: 'processingContent',
      render: (text: string) => (
        <Typography.Text className='whitespace-normal break-words text-[14px]/[18px] text-[#141414]'>
          {text}
        </Typography.Text>
      ),
      width: '35%'
    },
    {
      title: (
        <Typography.Text className='text-[12px]/[20px] font-semibold text-[#868D97]'>Tên loại yêu cầu</Typography.Text>
      ),
      dataIndex: 'requestTypeName',
      render: (text: string) => (
        <Typography.Text className='whitespace-normal break-words text-[14px]/[18px] text-[#141414]'>
          {text}
        </Typography.Text>
      ),
      width: '35%'
    },
    {
      title: (
        <Typography.Text className='text-[12px]/[20px] font-semibold text-[#868D97]'>Mã công việc</Typography.Text>
      ),
      dataIndex: 'jobCode',
      render: (text: string) => <Typography.Text className='text-[14px]/[18px] text-[#141414]'>{text}</Typography.Text>,
      width: '15%'
    }
  ];

  return (
    <Card
      title={
        <Typography.Text className='flex w-full justify-start text-[24px]/[32px] font-semibold'>
          {requestform.cmisProcessingProgress}
        </Typography.Text>
      }
      className='border-none text-center'
    >
      <Table
        className='cmis_table max-h-[1000px] overflow-y-auto border-none'
        columns={menuCmis}
        dataSource={[...cmisProcessingProgress]}
        pagination={false}
      />
    </Card>
  );
};

export default ModalCmisProcessingProgress;
